module.exports = __webpack_public_path__ + "static/media/cardText.af36fdda.svg";